import { useDocumentSearch } from 'features/knowledgeDocumentViewer/components/advancedSearch/hooks/useDocumentSearch'
import type { DocumentSearchResult } from 'features/knowledgeDocumentViewer/components/advancedSearch/utils/documentSearchApiSchemas'

interface UseUnifiedDocumentSearchArgs {
  enabled: boolean
  siteId: string
  searchQuery: string
  limit?: number
}

interface UseUnifiedDocumentSearchResult {
  rawDocumentSearchData: DocumentSearchResult | undefined
  streamingSearchData: undefined
  isLoadingSearch: boolean
  searchLatencyMs: number | undefined
  refreshDocumentSearch: () => void
}

export function useUnifiedDocumentSearch({
  enabled,
  siteId,
  searchQuery,
  limit = 200,
}: UseUnifiedDocumentSearchArgs): UseUnifiedDocumentSearchResult {
  const {
    data: rawDocumentSearchData,
    isLoading: isLoadingSearch,
    mutate: refreshRawDocumentSearch,
    searchLatencyMs,
  } = useDocumentSearch(
    {
      query: searchQuery,
      site_id: siteId,
      limit,
    },
    undefined,
    'unified',
    { enabled }
  )

  return {
    rawDocumentSearchData,
    streamingSearchData: undefined,
    isLoadingSearch,
    searchLatencyMs,
    refreshDocumentSearch: () => {
      if (!enabled || !searchQuery.trim()) return
      void refreshRawDocumentSearch()
    },
  }
}
